import React from 'react';
import { ConfigProvider } from 'antd';
import ruRU from 'antd/es/locale/ru_RU';

// eslint-disable-next-line max-len
// https://ant.design/docs/react/faq#How-do-I-prevent-Select-Dropdown-DatePicker-TimePicker-Popover-Popconfirm-scrolling-with-the-page

/**
 * @hoc Инициализация antd для корректного использования компонентов
 * @remark Для попапов в системе - возвращаем parentElement (для фикса бага) или document.body (defaultValue)
 * @see https://github.com/ani-team/github-client/issues/162#issuecomment-736676022
 */
const withAntd = (component: () => React.ReactNode) => () =>
  (
    <ConfigProvider
      locale={ruRU}
      getPopupContainer={(triggerNode: HTMLElement | undefined) =>
        (triggerNode?.parentNode as HTMLElement) || document.body
      }
    >
      {component()}
    </ConfigProvider>
  );
export default withAntd;
